// extracted by mini-css-extract-plugin
module.exports = {"input":"InputText_input__1WR0s","labelEffect":"InputText_labelEffect__1NW7V","iconInput":"InputText_iconInput__1SsG0","iconError":"InputText_iconError__2DrC9"};